import { useEffect, useMemo, useState } from 'react';
import { ThemeProvider } from 'styled-components';

import { AiIcon } from './components/AiIcon/AiIcon';
import { Chat } from './components/Chat/Chat';
import { ChatPanel } from './components/ChatPanel/ChatPanel';
import { Floyd } from './components/Floyd/Floyd';
import { OcSkeletonDefs } from './components/Loading/SkeletonSVG';
import { useAppContext } from './store/App/utils/useAppContext';
import { appTheme } from './styles/Theme';

function App({
  startOpen = false,
}: Readonly<{
  startOpen?: boolean;
}>) {
  const { state } = useAppContext();
  const { isDark } = state;

  const [showPanel, setShowPanel] = useState<boolean>(startOpen);
  const [stopAnimation, setStopAnimation] = useState<boolean>(startOpen);

  const theme = useMemo(
    () => (isDark ? appTheme().dark : appTheme().light),
    [isDark],
  );

  // After the initial render, always allow the opening animation to play
  useEffect(() => {
    setTimeout(() => {
      setStopAnimation(false);
    }, 100);
  }, []);

  const togglePanel = () => setShowPanel((current) => !current);

  return (
    <ThemeProvider theme={theme}>
      <OcSkeletonDefs />
      <ChatPanel
        show={showPanel}
        stopAnimation={stopAnimation}
        onHide={togglePanel}
      >
        <Chat branding={<Floyd />} />
      </ChatPanel>
      <AiIcon onClick={togglePanel} />
    </ThemeProvider>
  );
}

export default App;
